module.exports = __webpack_public_path__ + "public/img/creditProduct.a162a5d3.png";